import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VafLogResponseComponent } from './vaf-log-response-component.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgxFileDropModule } from 'ngx-file-drop';
import { NgChartsModule } from 'ng2-charts'
@NgModule({
  declarations: [VafLogResponseComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ReactiveFormsModule,
    NgxFileDropModule,
    NgChartsModule
  ],
  exports: [
    VafLogResponseComponent
  ]
})
export class VafLogResponseComponentModule { }
